import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ConflictError, AppErrors, NotFoundError, BadRequestError } from '@fitness-force/models';;
import type { CreateResponse, RefundList, CreateRefundRequest } from '@fitness-force/models';
import { environment } from '@fitness-force/environments';
import { Observable, map, catchError, throwError } from 'rxjs';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root'
})
export class RefundService {
  private http = inject(HttpClient);
  private router = inject(Router);

  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  getRefund(clientId: any): Observable<RefundList> {
    const url = `${environment.BASE_URL}/clients/${clientId}/refunds`
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }


  CreateRefund(tenantId: number, client_id:number, paymentId:number, data:CreateRefundRequest):Observable<CreateResponse> {
    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.CLIENT.CREATE_REFUND
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', client_id.toString())
      .replace('{payment_id}', paymentId.toString()), data,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  VoidRefund(tenantId: number, client_id:number, RefundId: number,data:any):Observable<any> {
    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.CLIENT.VOID_REFUND
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', client_id.toString())
      .replace('{refund_id}', RefundId.toString()), data,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  
  SendRefundPdf(client_id:number,RefundId: number, channels:any[]):Observable<any> {
    return this.http.post(`${environment.BASE_URL}/clients/${client_id}/refund/${RefundId}/pdf_refund`,channels,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  GetRefundPrint(client_id:number,RefundId: number):Observable<any> {
    const url= `${environment.BASE_URL}/clients/${client_id}/refund/${RefundId}/pdf_refund`;
      return this.http.get(url)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  CreateCreditBalanceRefund(tenantId: number, client_id:number, data:CreateRefundRequest):Observable<CreateResponse> {
    return this.http.post(environment.BASE_URL + CONST_URL_SEGEMENTS.CLIENT.CREATE_CREDIT_BALANCE_REFUND
      .replace('{tenant_id}', tenantId.toString())
      .replace('{client_id}', client_id.toString()), data,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
}
